// QuoteItemDetail.js
import React, {useState} from 'react';
import { Box, ListItem, ListItemText, Typography } from '@mui/material';
import { LoadingButton } from "@mui/lab";
import { OrderClaimDialog } from "../OrderClaimDialog/OrderClaimDialog";

const QuoteItemDetail = ({ quote, mode, isUpgrade = true }) => {
   const [openClaimDialog, setOpenClaimDialog] = useState(false);
   
   const renderContentByMode = () => {
      switch (mode) {
         case "auto":
            return (
               <>
                  <Typography sx={{ display: 'block' }} component="span" variant="body2" color="text.primary">
                     {quote.vehicle_make_model && `Vehicle: ${quote.vehicle_make_model}`}
                  </Typography>
               </>
            );
         case "material":
            return (
               <>
                  <Typography variant="body2">
                     Material Type: {quote.materialType}
                  </Typography>
                  <Typography variant="body2">
                     Total Weight: {quote.totalWeight} lbs
                  </Typography>
               </>
            );
         case "marine":
            return (
               <>
                  <Typography variant="body2">
                     Vessel Type: {quote.vesselType}
                  </Typography>
                  {quote.vesselName && (
                     <Typography variant="body2">
                        Vessel Name: {quote.vesselName}
                     </Typography>
                  )}
               </>
            );
         default:
            return null;
      }
   };
   
   const renderUpsell = () => {
      if (!isUpgrade) return null;
      return (
         <Box
            sx={{
               borderRadius: 2,
               px: 0,
               py: 1,
               mb: 1,
               mt: 1,
               border: `1px solid ${theme => theme.palette.secondary.main}`,
               fontWeight: 500,
               display: 'flex',
               alignItems: 'center',
               gap: 1
            }}
         >
            <Typography variant="body2" color="info.main">
               Faster Booking!
            </Typography>
         </Box>
      );
   };
   
   return (
      <ListItem
         alignItems="flex-start"
         secondaryAction={
            <LoadingButton
               loading={openClaimDialog}
               variant="outlined"
               onClick={() => setOpenClaimDialog(true)}
            >
               Claim
            </LoadingButton>
         }
         sx={{
            '.MuiListItemText-multiline': {
               marginRight: (theme) => theme.spacing(7),
            }
         }}
      >
         <ListItemText
            primary={<span style={{ fontSize: '1.3rem', color: '#111', fontWeight: 'bold' }}>{`$${quote.price.toFixed(2)}`}</span>}
            secondary={
               <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                  {renderUpsell()}
                  {renderContentByMode()}
                  <Typography variant="body2">
                     <b style={{color:'#111'}}>Pick-up:</b> {quote.pickup.location.address}
                  </Typography>
                  <Typography variant="body2">
                     <b style={{color:'#111'}}>Drop-off:</b> {quote.dropoff.location.address}
                  </Typography>
                  {quote.specialRequirements && (
                     <Typography variant="body2">
                        <b style={{color:'#111'}}>Special Requirements:</b> {quote.specialRequirements}
                     </Typography>
                  )}
               </Box>
            }
         />
         <OrderClaimDialog
            isOpen={openClaimDialog}
            quote={quote}
            onClose={() => setOpenClaimDialog(false)}
         />
      </ListItem>
   );
};

export default QuoteItemDetail;
